import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors.ts';

const ToastContainer = styled.div`
  position: fixed;
  left: ${props => props.x}px;
  top: calc(${props => props.y}px - 2rem);
  z-index: 100000000;
  transform: translate(-50%, -100%);
  transition: opacity 0.4s ease-in-out;
  opacity: ${props => props.isVisible ? '1' : '0'};
  pointer-events: none;
`;

const ToastContent = styled.div`
  background: ${colors.black};
  backdrop-filter: blur(12px);
  color: ${colors.white};
  padding: 1rem 1.5rem;
  border-radius: 10rem;
  box-shadow: 0 4px 12px ${colors.black}50;
  font-size: 0.8rem;
  font-weight: 500;
  max-width: 300px;
  display: flex;
  text-align: center;
  align-items: center;
  gap: 0.5rem;
`;

const ToastIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    height: 0.8rem;
    width: 0.8rem;
    
  }

  & path {
    fill: ${colors.white};
  }
`;

const Toast = ({ 
  isVisible, 
  message, 
  duration = 3000, 
  onClose,
  initialPosition = { x: 0, y: 0 }
}) => {
  const [mousePosition, setMousePosition] = useState(initialPosition);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  useEffect(() => {
    if (isVisible) {
      // Set initial position immediately
      setMousePosition(initialPosition);
      
      // Start tracking mouse movement
      const updateMousePosition = (e) => {
        setMousePosition({ x: e.clientX, y: e.clientY });
      };

      window.addEventListener('mousemove', updateMousePosition);
      
      return () => {
        window.removeEventListener('mousemove', updateMousePosition);
      };
    }
  }, [isVisible, initialPosition]);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
    } else {
      // Delay hiding to allow fade out
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 400); // Match transition duration
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!shouldRender) return null;

  return (
    <ToastContainer 
      isVisible={isVisible}
      x={mousePosition.x}
      y={mousePosition.y}
    >
      <ToastContent>
        <ToastIcon>
          <svg width="25" height="28" viewBox="0 0 25 28">
            <path d="M3.19282 28C2.49808 28 1.90335 27.7508 1.40861 27.2523C0.913872 26.7538 0.666504 26.1545 0.666504 25.4545V7.63636H3.19282V25.4545H17.0876V28H3.19282ZM8.24545 22.9091C7.55071 22.9091 6.95598 22.6598 6.46124 22.1614C5.9665 21.6629 5.71914 21.0636 5.71914 20.3636V2.54545C5.71914 1.84545 5.9665 1.24621 6.46124 0.747727C6.95598 0.249242 7.55071 0 8.24545 0H17.0876L24.6665 7.63636V20.3636C24.6665 21.0636 24.4191 21.6629 23.9244 22.1614C23.4297 22.6598 22.8349 22.9091 22.1402 22.9091H8.24545ZM15.8244 8.90909H22.1402L15.8244 2.54545V8.90909Z" />
          </svg>
        </ToastIcon>
        {message}
      </ToastContent>
    </ToastContainer>
  );
};

export default Toast;
